import { render, staticRenderFns } from "./OnForDelivery.vue?vue&type=template&id=adadb12c&"
import script from "./OnForDelivery.vue?vue&type=script&lang=js&"
export * from "./OnForDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports